export const selectOption = (option) => {

    return function(dispatch) {

        fetch(option.phpURL)
            .then(response => response.json())
            .then(data => {
                if (data.logged) {
                    dispatch({
                        type: "OPTION_SELECTED",
                        payload: {'data': data, 'option': option}
                    });
                    dispatch({
                        type: "RESET_FORM"
                    });
                }
                else {
                    window.location.reload(true);
                }
            })
            .catch((error) => {
                dispatch({
                    type: "OPTION_SELECTED",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/selectOption.js